<template>
    <footer
        v-if="dynamicComponents"
        :style="componentStyles"
        class="o-footer footer"
    >
        <template
            v-for="item in dynamicComponents"
        >
            <component
                :is="item"
                :key="item"
                :view="view"
            />
        </template>
    </footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "OFooter",
    components: {
        ABackButton: () => import('../../atoms/a-back-button'),
        AHomeButton: () => import('../../atoms/a-home-button'),
        MMobileMap: () => import('../../molecules/m-mobile-map'),
        MVersions: () => import('../../molecules/m-versions/m-versions'),
        OFooterButtons: () => import('../o-footer-buttons/o-footer-buttons'),
        ONavButtonsBlock: () => import('../../organisms/o-nav-buttons-block'),
        ACompanyInfo: () => import('../../atoms/a-company-info/a-company-info'),
        ASearchButton: () => import('../../atoms/a-search-button/a-search-button'),
        ABrandsButton: () => import('../../atoms/a-brands-button/a-brands-button'),
        MButtonOpeningHours: () => import('../../molecules/m-button-opening-hours'),
        OInvokeKeyboardButton: () => import('../../organisms/o-invoke-keyboard-button'),
        AServicesButton: () => import('../../atoms/a-services-button/a-services-button'),
        OServicesButtons: () => import('../../organisms/o-services-buttons/o-services-buttons'),
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        dynamicComponents() {
            return Object.keys(this.getMapConfigProp(`views.${this.view}.footer`)) || [];
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OFooter.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.OFooter.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        }
    }
}
</script>

<style lang="scss">
@import "o-footer";
</style>
